module.exports = __webpack_public_path__ + "img/icon-component-label_Coupon.ef2a5236.svg";